import React, { useReducer } from "react";
import {
  CLEAR_ATTENDANCE_HISTORY,
  GET_ATTENDANCE_HISTORY,
  SET_ATTENDANCE_HISTORY_PAGINATION,
  SET_LOADING,
} from "../types";
import AttendanceContext from "./attendanceContext";
import AttendanceReducer from "./attendanceReducer";
import storage from "../../helpers/storage";
import axiosInstance from "../../services/axios.service";

// GET /attendance?participant=&event=&startDate=&endDate=&_limit=&_page=
//
// Paging uses the names the API reads. `limit` and `page` were sent
// instead, so the page size was ignored on every request.
const AttendanceState = (props) => {
  const initialState = {
    attendanceHistory: [],
    attendanceHistoryPagination: {},
    loading: false,
  };

  const [state, dispatch] = useReducer(AttendanceReducer, initialState);

  const setLoading = () => {
    dispatch({
      type: SET_LOADING,
    });
  };

  const getAttendanceHistory = async ({
    participant,
    event,
    startDate,
    endDate,
    limit = 30,
    page = 1,
  } = {}) => {
    const params = new URLSearchParams();
    if (participant) params.append("participant", participant);
    if (event) params.append("event", event);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    params.append("_limit", limit);
    params.append("_page", page);

    setLoading();
    try {
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/attendance?${params.toString()}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_ATTENDANCE_HISTORY_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_ATTENDANCE_HISTORY,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      console.error("Error in getAttendanceHistory:", error);
      dispatch({
        type: GET_ATTENDANCE_HISTORY,
        payload: [],
      });
    }
  };

  const clearAttendanceHistory = () => {
    dispatch({
      type: CLEAR_ATTENDANCE_HISTORY,
    });
  };

  return (
    <AttendanceContext.Provider
      value={{
        attendanceHistory: state.attendanceHistory,
        attendanceHistoryPagination: state.attendanceHistoryPagination,
        loading: state.loading,
        getAttendanceHistory,
        clearAttendanceHistory,
      }}
    >
      {props.children}
    </AttendanceContext.Provider>
  );
};

export default AttendanceState;
